import { render, staticRenderFns } from "./DashboardPerformance.vue?vue&type=template&id=d6f7b2b8"
import script from "./DashboardPerformance.vue?vue&type=script&lang=js"
export * from "./DashboardPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports